// extracted by mini-css-extract-plugin
export default {"autocompleteContainer":"projectAutocomplete_autocompleteContainer__dlguf","titleValue1":"projectAutocomplete_titleValue1__nudvD","cancelIcon":"projectAutocomplete_cancelIcon__iUDFh"};